module.exports = __webpack_public_path__ + "static/media/6.c42938a2.png";